<template>
  <div v-show="visible" class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">Temperature</h2>
    </div>

    <div class="part__cnt">
      <div v-if="labelsHasData" class="label_style mt-3">
        <ul v-for="item in labels" :key="item.label">
          <li>{{ item.label }}</li>
          <li>{{ item.value || '-' }}</li>
        </ul>
      </div>

      <div v-show="hasData(tempDataFields)" class="position-relative">
        <div
          id="temp_line"
          style="width: 100%; height: 400px"
        ></div>
        <div id="temp_line_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="temp_line_chart" />
        <chart-rect ref="chartRect1" chartKey="temp_line_chart" />
      </div>

      <div v-show="hasData(electricDataFields)" class="position-relative">
        <div
          id="electric_line"
          style="width: 100%; height: 400px"
        ></div>
        <label-list ref="labelList2" :perf_second_data="perf_second_data" chartKey="electric_line_chart" />
        <chart-rect ref="chartRect2" chartKey="electric_line_chart" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart, arrNotEmpty} from '../common.js'
import ChartRect from '../rect.vue'

const useTemp = {
  data() {
    return {
    }
  },

  computed: {
    tempDataFields() {
      const result = ['BTemp[℃]']
      if (this.testInfo0?.device?.toUpperCase()?.indexOf("IPHONE") == -1) { //如果不是iphone
        result.push('CTemp[℃]')
      }

      return result
    }
  },

  methods: {
    getTempSeries() {
      let result = [
        {
          name: "CTemp",
          type: "line",
          showSymbol: false,
          data: this.secondData?.["CTemp[℃]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "Gtemp",
          type: "line",
          // showSymbol: true,
          // showAllSymbol: true,
          // symbolSize: 2,
          data: this.secondData?.["GTemp[℃]"]?.map(item => (item || item === 0) ? Number(item) : null),
          //connectNulls: true,
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "Gtemp",
          type: "line",
          // showSymbol: true,
          // showAllSymbol: true,
          // symbolSize: 2,
          data: this.secondData?.["Gtemp[℃]"]?.map(item => (item || item === 0) ? Number(item) : null),
          //connectNulls: true,
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "NTemp",
          type: "line",
          // showSymbol: true,
          // showAllSymbol: true,
          // symbolSize: 2,
          data: this.secondData?.["NTemp[℃]"]?.map(item => (item || item === 0) ? Number(item) : null),
          //connectNulls: true,
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "BTemp",
          type: "line",
          // showSymbol: true,
          // showAllSymbol: true,
          // symbolSize: 2,
          data: this.secondData?.["BTemp[℃]"]?.map(item => (item || item === 0) ? Number(item) : null),
          //connectNulls: true,
          itemStyle: this.chartSettings.itemStyle2,
        },
      ]

      return result
    },

    getTemp_lineOption() {
      return {
        title: {
          text: "手机温度",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.getTempSeries()
      }
    },

    drawPieChartTemp() {
      let chartDom = document.getElementById("temp_line")
      if (!chartDom) return
      if (!allChart.temp_line_chart) {
        allChart.temp_line_chart = echarts.init(chartDom)
      }
      allChart.temp_line_chart.setOption(this.getTemp_lineOption(), {notMerge: true})
    },
  }
}

const useElectric = {
  data() {
    return {
    }
  },

  computed: {
    electricDataFields() {
      return ['electric_pcnt']
    }
  },

  methods: {
    getElectric_lineOption() {
      return {
        title: {
          text: "手机电量",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: [
          {
            name: "electric_pcnt",
            type: "line",
            showSymbol: false,
            data: this.secondData?.['electric_pcnt'],
          }
        ]
      }
    },

    drawPieChartElectric() {
      let chartDom = document.getElementById("electric_line")
      if (!chartDom) return
      if (!allChart.electric_line_chart) {
        allChart.electric_line_chart = echarts.init(chartDom)
      }
      allChart.electric_line_chart.setOption(this.getElectric_lineOption(), {notMerge: true})
    },
  }
}

export default {
  mixins: [useTemp, useElectric],

  inject: ['injectObj', 'hasData'],

  components: {LabelList, ChartRect},

  props: {
    testInfo3: Object,
    testInfo: Object,
    testInfo0: Object,
    netNewFieldsData: Array,
    testInfo2: Object,
    labelInfo: Array,
    selectedRow: Array,
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {

    }
  },

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    labels() {
      let label = this.testInfo3

      return [
        {label: 'Avg(CTemp)[°C])', value: label?.['Avg(CTemp)[℃]']},
        {label: 'Avg(GTemp)[°C])', value: label?.['Avg(GTemp)[℃]']},
        {label: 'Avg(NTemp)[°C])', value: label?.['Avg(NTemp)[°C])']},
        {label: 'Avg(BTemp)[°C])', value: label?.['Avg(BTemp)[℃]']},
      ]
    },

    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    labelsHasData() {
      return arrNotEmpty(this.labels)
    },

    visible() {
      return this.labelsHasData || this.hasData(this.tempDataFields) || this.hasData(this.electricDataFields)
    },
  },

  methods: {
    drawCharts() {
      this.drawPieChartTemp()
      this.drawPieChartElectric()
    },

    async init(isMounted) {
      this.drawCharts()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
      // this.$refs.chartRect2?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>